var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as Bluebird from "bluebird";
var userService = require("users/userService").default;
var keyStore = require("services/keyStore.service").default;
import SecuredDataApi, { SecuredData } from "../asset/securedDataWithMetaData";
import h from "../helper/helper";
import socket from "../services/socket.service";
import ObjectLoader from "../services/cachedObjectLoader";
import ChunkLoader from "./chatChunk";
import blobService from "../services/blobService";
import Progress from "../asset/Progress";
import settings from "../services/settings.service";
var extractImagesInfo = function (infos, key) {
    return infos.map(function (info) {
        return h.objectMap(info, function (val) { return val[key]; });
    });
};
var Message = /** @class */ (function () {
    function Message(messageData, chat, attachments, id) {
        var _this = this;
        this.initialize = function (_a) {
            var meta = _a.meta, content = _a.content, server = _a.server, sender = _a.sender;
            _this.wasSent = true;
            var _b = Message.idFromData(server), serverID = _b.serverID, clientID = _b.clientID;
            _this.serverID = serverID;
            _this.clientID = clientID;
            _this.previousID = server.previousMessage;
            _this.chunkID = server.chunkID;
            _this.sendTime = h.parseDecimal(server.sendTime);
            _this.securedData = new SecuredData(content, meta, { type: "message" }, true);
            _this.setDefaultData();
            _this.data.sender = sender.data;
            _this.isOwnMessage = sender.isOwn();
            _this.setAttachmentInfo("files");
            _this.setAttachmentInfo("voicemails");
            _this.setImagesInfo();
        };
        this.initializePending = function (chat, message, attachments, id) {
            _this.wasSent = false;
            _this.chat = chat;
            _this.attachments = attachments;
            _this.clientID = id || h.generateUUID();
            var meta = {
                createTime: new Date().getTime(),
                messageUUID: _this.clientID
            };
            _this.securedData = Message.createRawSecuredData(message, meta);
            _this.setDefaultData();
            _this.data.sender = userService.getOwn().data;
            _this.isOwnMessage = true;
            _this.data.images = attachments.images.map(function (image) {
                if (!image.convertForGallery) {
                    return image;
                }
                return image.convertForGallery();
            });
            _this.data.files = attachments.files.map(function (file) { return (__assign({}, file.getInfo(), { getProgress: function () {
                    return file.getProgress();
                } })); });
            _this.data.voicemails = attachments.voicemails.map(function (voicemail) { return (__assign({}, voicemail.getInfo(), { getProgress: function () {
                    return voicemail.getProgress();
                } })); });
            _this.prepareAttachments();
        };
        this.hasAttachments = function () {
            return _this.attachments.images.length !== 0 || _this.attachments.files.length !== 0 || _this.attachments.voicemails.length !== 0;
        };
        this.isBlockedSince = function () {
            return settings.isBlockedSince(_this.data.sender.id, _this.getTime());
        };
        this.isBlocked = function () {
            return settings.isBlocked(_this.data.sender.id);
        };
        this.hasFiles = function () {
            return _this.data.files && _this.data.files.length > 0;
        };
        this.hasVoicemail = function () {
            return _this.data.voicemails && _this.data.voicemails.length > 0;
        };
        this.hasText = function () {
            return _this.data.text && _this.data.text.length > 0;
        };
        this.hasImages = function () {
            return _this.data.images && _this.data.images.length > 0;
        };
        this.prepareAttachments = function () {
            return Bluebird.all([
                Message.prepare(_this.attachments.files),
                Message.prepare(_this.attachments.images),
                Message.prepare(_this.attachments.voicemails)
            ]);
        };
        this.setDefaultData = function () {
            var content = _this.securedData.contentGet();
            _this.data = {
                text: typeof content === "string" ? content : content.message,
                timestamp: _this.getTime(),
                date: new Date(_this.getTime()),
                sent: _this.wasSent,
                id: _this.clientID,
                obj: _this
            };
        };
        this.getChunkID = function () {
            return _this.chunkID || _this.chat.getLatestChunk();
        };
        this.hasBeenSent = function () { return _this.wasSent; };
        this.uploadAttachments = h.cacheResult(function (chunkKey) {
            return _this.prepareAttachments().then(function () {
                var attachments = _this.attachments.images.concat(_this.attachments.files, _this.attachments.voicemails);
                return Bluebird.all(attachments.map(function (attachment) {
                    return attachment.upload(chunkKey);
                }));
            }).then(function (imageKeys) {
                return h.array.flatten(imageKeys);
            });
        });
        this.sendContinously = h.cacheResult(function () {
            return h.repeatUntilTrue(Bluebird, function () {
                return _this.send();
            }, 2000);
        });
        this.send = function () {
            if (_this.wasSent) {
                throw new Error("trying to send an already sent message");
            }
            return Bluebird.try(function () { return __awaiter(_this, void 0, void 0, function () {
                var _this = this;
                var messageIDs, messages, unsentMessages, messageIndex, chunk, chunkKey, sentMessages, newest, signAndEncryptPromise, keys, request, _a, receiverKeys, chunkKeys, initialChunk, response_1, chatInfo, messageInfo, chunkInfo, response;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, socket.awaitConnection()];
                        case 1:
                            _b.sent();
                            messageIDs = this.chat.getMessages();
                            messages = messageIDs.filter(function (_a) {
                                var id = _a.id;
                                return MessageLoader.isLoaded(id);
                            }).map(function (_a) {
                                var id = _a.id;
                                return MessageLoader.getLoaded(id);
                            });
                            unsentMessages = messages.filter(function (m) { return !m.hasBeenSent(); });
                            messageIndex = unsentMessages.findIndex(function (m) { return m === _this; });
                            if (!unsentMessages[messageIndex - 1]) return [3 /*break*/, 3];
                            return [4 /*yield*/, unsentMessages[messageIndex - 1].sendContinously()];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3: return [4 /*yield*/, ChunkLoader.get(this.chat.getLatestChunk())];
                        case 4:
                            chunk = _b.sent();
                            this.securedData.setParent(chunk.getSecuredData());
                            return [4 /*yield*/, Message.setAttachmentsInfo(this.securedData, this.attachments)];
                        case 5:
                            _b.sent();
                            chunkKey = chunk.getKey();
                            sentMessages = messages.filter(function (m) { return m.hasBeenSent(); });
                            newest = h.array.last(sentMessages);
                            if (newest && newest.getChunkID() === this.chat.getLatestChunk()) {
                                this.securedData.setAfterRelationShip(newest.getSecuredData());
                            }
                            signAndEncryptPromise = this.securedData.signAndEncrypt(userService.getOwn().getSignKey(), chunkKey);
                            return [4 /*yield*/, this.uploadAttachments(chunkKey)];
                        case 6:
                            keys = (_b.sent()).map(keyStore.upload.getKey);
                            return [4 /*yield*/, signAndEncryptPromise];
                        case 7:
                            request = _b.sent();
                            if (!this.chat.isDraft()) return [3 /*break*/, 9];
                            _a = chunk.chunkData, receiverKeys = _a.receiverKeys, chunkKeys = _a.keys, initialChunk = _a.chunk;
                            return [4 /*yield*/, socket.emit("chat.create", {
                                    initialChunk: initialChunk,
                                    firstMessage: request,
                                    receiverKeys: receiverKeys,
                                    keys: chunkKeys.concat(keys)
                                })];
                        case 8:
                            response_1 = _b.sent();
                            chatInfo = response_1.chat.chat;
                            messageInfo = response_1.chat.messages[0];
                            chunkInfo = response_1.chat.chunks[0];
                            chunk.create(chunkInfo);
                            this.chat.create(chatInfo);
                            this.sendSuccess();
                            this.setServerInfo(messageInfo.server);
                            return [2 /*return*/, true];
                        case 9: return [4 /*yield*/, socket.emit("chat.message.create", {
                                chunkID: chunk.getID(),
                                message: request,
                                keys: keys
                            })];
                        case 10:
                            response = _b.sent();
                            if (response.success) {
                                this.sendSuccess();
                            }
                            if (response.server) {
                                this.setServerInfo(response.server);
                            }
                            return [2 /*return*/, response.success];
                    }
                });
            }); }).catch(socket.errors.Disconnect, function (e) {
                console.warn(e);
                return false;
            }).catch(socket.errors.Server, function () {
                return false;
            });
        };
        this.sendSuccess = function () {
            _this.wasSent = true;
            _this.data.sent = true;
            _this.setAttachmentInfo("files");
            _this.setAttachmentInfo("voicemails");
            _this.setImagesInfo();
        };
        this.setServerInfo = function (_a) {
            var sendTime = _a.sendTime, id = _a.id, chunkID = _a.chunkID, previousMessage = _a.previousMessage;
            _this.sendTime = h.parseDecimal(sendTime);
            _this.serverID = h.parseDecimal(id);
            _this.chunkID = h.parseDecimal(chunkID);
            _this.previousID = previousMessage;
            _this.data.timestamp = _this.getTime();
        };
        this.getSecuredData = function () {
            return _this.securedData;
        };
        this.getServerID = function () {
            return _this.serverID;
        };
        this.getPreviousID = function () {
            return _this.previousID;
        };
        this.getClientID = function () {
            return _this.clientID;
        };
        this.getTopicID = function () {
            return _this.chunkID;
        };
        this.getTime = function () {
            if (_this.getServerID()) {
                return _this.sendTime;
            }
            return h.parseDecimal(_this.securedData.metaAttr("createTime"));
        };
        this.isOwn = function () {
            return _this.isOwnMessage;
        };
        this.verifyParent = function (chunk) {
            _this.securedData.checkParent(chunk.getSecuredData());
        };
        this.getText = function () {
            return _this.data.text;
        };
        this.setAttachmentInfo = function (attr) {
            var fullContent = _this.securedData.contentGet();
            if (typeof fullContent === "string") {
                return;
            }
            var content = fullContent[attr];
            var meta = _this.securedData.metaAttr(attr);
            if (!content) {
                return;
            }
            _this.data[attr] = content.map(function (file, index) { return (__assign({}, file, meta[index], { loaded: false })); });
            Bluebird.resolve(_this.data[attr]).filter(function (ele) {
                return blobService.isBlobLoaded(ele.blobID);
            }).each(function (loadedAttachment) {
                loadedAttachment.loaded = true;
            });
        };
        this.downloadVoicemail = function (voicemailDownloadProgress) {
            return Bluebird.resolve(_this.data.voicemails).each(function (voicemail) {
                var progress = new Progress();
                voicemailDownloadProgress.addDepend(progress);
                return blobService.getBlobUrl(voicemail.blobID, voicemail.type, voicemail.size, voicemailDownloadProgress).then(function (url) {
                    voicemail.url = url;
                    voicemail.loaded = true;
                });
            });
        };
        this.setImagesInfo = function () {
            var content = _this.securedData.contentGet();
            var imagesMeta = _this.securedData.metaAttr("images") || [];
            if (typeof content === "string") {
                _this.data.images = imagesMeta;
                return;
            }
            var imagesContent = content.images;
            _this.data.images = imagesMeta.map(function (imageMeta, index) {
                var imageContent = imagesContent[index];
                var data = h.objectMap(imageMeta, function (val, key) {
                    return __assign({}, val, imageContent[key]);
                });
                return data;
            });
        };
        if (chat) {
            this.initializePending(chat, messageData, attachments, id);
        }
        else {
            this.initialize(messageData);
        }
    }
    Message.createRawSecuredData = function (message, meta, chunk) {
        var secured = new SecuredData({ message: message }, meta, { type: "message" }, true);
        if (chunk) {
            secured.setParent(chunk.getSecuredData());
        }
        return secured;
    };
    Message.idFromData = function (server) {
        var serverID = h.parseDecimal(server.id);
        var clientID = server.uuid;
        return {
            serverID: serverID,
            clientID: clientID
        };
    };
    Message.prepare = function (uploads) { return Bluebird.resolve(uploads).map(function (upload) { return upload.prepare(); }); };
    Message.setAttachmentsInfo = function (securedData, attachments) {
        return Bluebird.try(function () {
            return __awaiter(this, void 0, void 0, function () {
                var imagesInfo, voicemailsInfo, filesInfo;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, Message.prepare(attachments.images)];
                        case 1:
                            imagesInfo = _a.sent();
                            return [4 /*yield*/, Message.prepare(attachments.voicemails)];
                        case 2:
                            voicemailsInfo = _a.sent();
                            return [4 /*yield*/, Message.prepare(attachments.files)];
                        case 3:
                            filesInfo = _a.sent();
                            if (imagesInfo.length > 0 || filesInfo.length > 0 || voicemailsInfo.length > 0) {
                                securedData.metaSetAttr("images", extractImagesInfo(imagesInfo, "meta"));
                                securedData.contentSetAttr("images", extractImagesInfo(imagesInfo, "content"));
                                securedData.metaSetAttr("files", filesInfo.map(function (info) { return info.meta; }));
                                securedData.contentSetAttr("files", filesInfo.map(function (info) { return info.content; }));
                                securedData.metaSetAttr("voicemails", voicemailsInfo.map(function (info) { return info.meta; }));
                                securedData.contentSetAttr("voicemails", voicemailsInfo.map(function (info) { return info.content; }));
                            }
                            else if (typeof securedData.contentGet() !== "string") {
                                securedData.contentSet(securedData.contentGet().message);
                            }
                            return [2 /*return*/];
                    }
                });
            });
        });
    };
    return Message;
}());
export { Message };
var loadMessageSender = function (senderID) {
    return userService.get(senderID)
        .then(function (sender) { return sender.loadBasicData().thenReturn(sender); });
};
var MessageLoader = /** @class */ (function (_super) {
    __extends(MessageLoader, _super);
    function MessageLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MessageLoader;
}(ObjectLoader({
    cacheName: "message",
    getID: function (_a) {
        var server = _a.server;
        return server.uuid;
    },
    download: function (id) { return socket.definitlyEmit("chat.message.get", { id: id }); },
    load: function (messageResponse) {
        var content = messageResponse.content, meta = messageResponse.meta, server = messageResponse.server;
        var securedData = SecuredDataApi.load(content, meta, { type: "message" });
        var senderID = server.sender;
        // !! Typescript is broken for async arrow functions without a this context !!
        return Bluebird.try(function () {
            return __awaiter(this, void 0, void 0, function () {
                var sender;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, loadMessageSender(senderID)];
                        case 1:
                            sender = _a.sent();
                            return [4 /*yield*/, Bluebird.all([
                                    securedData.decrypt(),
                                    sender.isNotExistingUser() ? false : securedData.verify(sender.getSignKey())
                                ])];
                        case 2:
                            _a.sent();
                            return [2 /*return*/, {
                                    content: securedData.contentGet(),
                                    meta: securedData.metaGet(),
                                    server: messageResponse.server,
                                }];
                    }
                });
            });
        });
    },
    restore: function (messageInfo) {
        return loadMessageSender(messageInfo.server.sender)
            .then(function (sender) { return new Message(__assign({}, messageInfo, { sender: sender })); });
    },
})));
export default MessageLoader;



//////////////////
// WEBPACK FOOTER
// ./js/messages/message.ts
// module id = sxTB
// module chunks = 1